import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BLService } from './bl.service';

@Injectable()
export class DataSafeService extends BLService {
  private url = 'https://apireg.blinfo.se/data-safe/deposit/nbr/10';

  storeInvite(blappInvite: string): Observable<string> {
    return this.http.post<string>(this.url, blappInvite).pipe(this.catchErrorAndShowMessage());
  }
}
